<div class="modal-header">
  <h4 class="modal-title">Select Alternative for: {{ data.demandItemName }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <p class="mb-3">
    This item has alternatives. Please select which SKU to use for the signoff:
  </p>

  <div class="alternatives-list">
    <div 
      *ngFor="let option of options" 
      class="alternative-option" 
      [class.selected]="selectedOption === option"
      [class.original]="option.isOriginal"
      (click)="selectOption(option)">
      
      <div class="option-header">
        <span class="badge" [class.bg-primary]="option.isOriginal" [class.bg-secondary]="!option.isOriginal">
          {{ option.isOriginal ? 'Original' : 'Alternative ' + option.order }}
        </span>
        <span class="selected-indicator" *ngIf="selectedOption === option">✓</span>
      </div>
      
      <div class="option-details">
        <div class="detail-row">
          <span class="label">SKU:</span>
          <span class="value">{{ option.sku }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Reserve Formula:</span>
          <span class="value">{{ option.reserveFormula || '—' }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Reserve:</span>
          <span class="value">{{ option.reserve }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Limit Formula:</span>
          <span class="value">{{ option.limitFormula || '—' }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Limit:</span>
          <span class="value">{{ option.limit }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-warning me-auto" (click)="clearSelection()">
    Clear Selection
  </button>
  <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!selectedOption">
    Confirm Selection
  </button>
</div>
